<template>
 <div class="unicom-progress"
      :class="percentage === 0 ? 'boder-0': '' ">
   <van-progress :percentage="percentage"
                pivot-color="#587DF1"
                color="#587DF1"/>
 </div>
</template>
<script>
export default {
  name: 'unicomProgress',
  props: {
    percentage: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>
<style lang="less">
.unicom-progress {
  position: absolute;
  top: 0.14rem;
  width: calc(100vw - 0.48rem);
  left: 50%;
  transform: translate(-50%, 0);
  border-radius: 0.24rem;
  background: #DFE6FE;
  .van-progress {
    height: 0.24rem;
    border-radius: 0.24rem;
    .van-progress__portion{
      height: 0.24rem;
      // border-radius: 0.24rem 0 0 0.24rem ;
      background: #587DF1;
      .van-progress__pivot{
        font-size: 0.22rem;
        height: 0.24rem;
        line-height: 0.24rem;
        border-radius:0  0.24rem 0.24rem 0;
        transform:translate(0%,0%);
        top: 0;
        transform: translate(97%,0);
      }
    }
  }
  &.boder-0 {
    .van-progress {
      .van-progress__portion{
        background: #587DF1;
        .van-progress__pivot{
          border-radius: 0.24rem;
        }
      }
    }
  }
}
</style>
